import { PropsWithChildren } from "react";

import './action-button.less';
import {AnchorTargetType} from "utils/helpers";

interface Props {
  href: string
  target?: AnchorTargetType
  className?: string
  disabled?: boolean
  noBorder?: boolean
}

export default function ActionButtonLink(props: PropsWithChildren<Props>) {
  let className = "btn btn-primary btn-action"
  if (props.className) {
    className += " " + props.className;
  }
  if (props.noBorder) {
    className += " no-border";
  }
  if (props.disabled) {
    className += " disabled";
  }

  return <a href={props.href} className={className} target={props.target}>
    {props.children}
  </a>
}